export const validate = (inputs, fromEditAction = null) => {
    const errors = {};

    if (inputs.textFontSize) {
        var pattern = /^\d+$/;
        if (!pattern.test(inputs.textFontSize)) {
            errors.textFontSize = "Required only digit";
        }
    }

    if (inputs.timeFontSize) {
        var pattern = /^\d+$/;
        if (!pattern.test(inputs.timeFontSize)) {
            errors.timeFontSize = "Required only digit";
        }
    }
    if (fromEditAction == "timer") {
        if (!inputs.deadLineDate) {
            errors.deadLineDate = "Please ender dealLine date";
        }
    }

    return errors;
}